import { Checkbox, CheckboxCheckedChangeDetails, Collapsible, Flex, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { memo, useCallback } from 'react';

import { allPriceRanges } from 'helpers/fakeData';
import { useBoolean } from 'hooks/useBoolean';
import { useStores } from 'stores/rootStore';
import RawArrowIcon from 'vectors/Arrowhead';

const PriceFilters = () => {
  const [isOpen, setIsOpen] = useBoolean(true);

  return (
    <Collapsible.Root unmountOnExit open={isOpen} onOpenChange={setIsOpen.toggle}>
      <Collapsible.Trigger paddingY="3" cursor="pointer">
        <Flex alignItems="center" gap="2">
          <Text fontWeight="medium">Shop by price</Text>
          <RawArrowIcon boxSize="8px" direction={isOpen ? 'up' : 'down'} />
        </Flex>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <CheckboxList />
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

const CheckboxList = observer(() => {
  const { marketPlaceStore } = useStores();

  const onCheckedChange = useCallback(
    (rangeId: string) => (details: CheckboxCheckedChangeDetails) => {
      if (details.checked !== 'indeterminate' && details.checked) {
        marketPlaceStore.addPriceRangeId(rangeId);
      } else {
        marketPlaceStore.removePriceRangeId(rangeId);
      }
    },
    [marketPlaceStore],
  );

  return (
    <Flex flexDirection="column" gap="2">
      {allPriceRanges.map((range) => (
        <Checkbox.Root
          key={range.id}
          variant="solid"
          cursor="pointer"
          onCheckedChange={onCheckedChange(range.id)}
          defaultChecked={marketPlaceStore.selectedPriceRangeIds.includes(range.id)}
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control borderColor="border.light">
            <Checkbox.Indicator />
          </Checkbox.Control>
          <Checkbox.Label>
            <Text fontWeight="light">{range.label}</Text>
          </Checkbox.Label>
        </Checkbox.Root>
      ))}
    </Flex>
  );
});

export default memo(PriceFilters);
